import { combineReducers } from 'redux';
import ShiftLogsReducer from './shiftLogsReducer';
import TeamShiftLogsReducer from './teamShiftLogsReducer';
import PreferenceReducer from './preferenceReducer';
export default combineReducers({
  ShiftLogsReducer: ShiftLogsReducer,
  TeamShiftLogsReducer: TeamShiftLogsReducer,
  PreferenceReducer: PreferenceReducer,
});
